import React from 'react';
export function CodeIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M9.707 6.207L8.293 4.793 1.086 12l7.207 7.207 1.414-1.414L3.914 12l5.793-5.793zm4.586 0l1.414-1.414L22.914 12l-7.207 7.207-1.414-1.414L20.086 12l-5.793-5.793z"
  }));
}